"use client";

import React, { Suspense } from "react";
import VehicleFormSection from "@/components/VehicleInputSection";

export default function MyInventory() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div className="p-6 overflow-y-auto">
        <VehicleFormSection />
      </div>
    </Suspense>
  );
}
